'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _lodash = _interopRequireDefault(require("lodash"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _conf = _interopRequireDefault(require("../../conf"));

var _stateList = _interopRequireDefault(require("../state-list"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var pad = function pad(nr) {
  return ('0' + nr).slice(-2);
};

var formatDate = function formatDate(dateStr) {
  var date = new Date(dateStr);
  return "".concat(date.getDate(), ".").concat(pad(date.getMonth() + 1), ".").concat(date.getFullYear()) + " - ".concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()));
};

var ProjectState = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectState, _React$Component);

  function ProjectState(props) {
    var _this;

    _classCallCheck(this, ProjectState);

    _this = _possibleConstructorReturn(this, (ProjectState.__proto__ || Object.getPrototypeOf(ProjectState)).call(this, props));
    _this.state = {
      data: [],
      isLoading: false
    };
    _this.projectStateData = null;
    _this.userStateData = {};
    _this.farmStateData = null;
    _this.membershipData = null;
    _this.staticTexts = {
      noData: props.t('no data'),
      loading: props.t('loading data')
    };
    _this.updateMembershipInfo = _this.updateMembershipInfo.bind(_assertThisInitialized(_this));
    _this.transformData = _this.transformData.bind(_assertThisInitialized(_this));
    _this.updateStatusesDisplay = _this.updateStatusesDisplay.bind(_assertThisInitialized(_this));
    _this.checkFarmData = _this.checkFarmData.bind(_assertThisInitialized(_this));
    _this.checkProject = _this.checkProject.bind(_assertThisInitialized(_this));
    _this.releaseProject = _this.releaseProject.bind(_assertThisInitialized(_this));
    _this.resetReleaseProject = _this.resetReleaseProject.bind(_assertThisInitialized(_this));
    _this.resetMembershipInfo = _this.resetMembershipInfo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProjectState, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadData();
      this.setState(function (prev) {
        prev.isLoading = true;
        return prev;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.projectData !== this.props.projectData) {
        this.setState(function (prev) {
          prev.data = _this2.transformData(_this2.projectStateData, _this2.userStateData, _this2.farmStateData, _this2.membershipData);
          return prev;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_stateList.default, {
        isLoading: this.state.isLoading,
        staticTexts: this.staticTexts,
        data: this.state.data,
        projectKey: this.props.projectKey
      }));
    }
    /**
     *
     * @param {{project_checked_by: object, project_checked_at: number}} projectStateData
     * @param {{email_verified: boolean}} userStateData
     * @param {{farm_checked_by: object, farm_checked_at: number}} farmStateData
     * @param {{membership_fee_checked_by: object, membership_fee_checked_at: number}} membershipData
     * @return {Array}
     */

  }, {
    key: "transformData",
    value: function transformData(projectStateData, userStateData, farmStateData, membershipData) {
      var _this3 = this;

      var farmIsChecked = false,
          membershipDataPayd = false,
          projectIsChecked = false,
          rowData = [],
          projectData = this.props.projectData || {};
      var requestToPublishOnClone = projectData.requesttopublishclone || false;

      if (farmStateData == null) {
        rowData.push({
          type: 'farm-state-data',
          subject: this.props.t('Farm data'),
          state: {
            icon: 'icon-close',
            color: 'red'
          }
        });
      } else {
        // Farm state
        farmIsChecked = farmStateData.farm_checked_by && farmStateData.farm_checked_at;
        var farmState = {
          type: 'farm-state-data',
          subject: this.props.t('farm data'),
          state: {
            icon: farmIsChecked ? 'icon-check' : 'icon-close',
            color: farmIsChecked ? 'green' : 'red'
          },
          info1: function info1() {
            if (farmIsChecked) return;
            return /*#__PURE__*/_react.default.createElement("button", {
              className: "btn btn--small",
              onClick: _this3.checkFarmData
            }, _this3.props.t('Check farm data'));
          }
        };

        if (farmIsChecked) {
          Object.assign(farmState, {
            info1: {
              icon: 'icon-user',
              text: farmStateData.farm_checked_by.email
            },
            info2: {
              icon: 'icon-date',
              text: formatDate(farmStateData.farm_checked_at)
            }
          });
        }

        rowData.push(farmState);
      } // @todo improve this


      if (membershipData == null) {
        rowData.push({
          type: 'membership-data',
          subject: this.props.t('Membership data'),
          state: {
            icon: 'icon-close',
            color: 'red'
          },
          info1: function info1() {
            return /*#__PURE__*/_react.default.createElement("button", {
              className: "btn btn--small",
              onClick: _this3.updateMembershipInfo
            }, _this3.props.t('Has membership payed'));
          }
        });
      } else {
        membershipDataPayd = true;
        rowData.push({
          type: 'membership-data',
          subject: this.props.t('Membership data'),
          state: {
            icon: 'icon-check',
            color: 'green'
          },
          info1: {
            icon: 'icon-user',
            text: membershipData.membership_fee_checked_by.email
          },
          info2: {
            icon: 'icon-date',
            text: formatDate(membershipData.membership_fee_checked_at)
          },
          info3: function info3() {
            return /*#__PURE__*/_react.default.createElement("button", {
              className: "btn btn--small",
              onClick: _this3.resetMembershipInfo
            }, _this3.props.t('Reset membership fee'));
          }
        });
      }

      if (projectData.date_create) {
        rowData.push({
          type: 'project-start-date',
          subject: this.props.t('project start'),
          state: {
            icon: 'icon-check',
            color: 'green'
          },
          info2: {
            icon: 'icon-date',
            text: formatDate(projectData.date_create)
          }
        });
      }

      rowData.push({
        type: 'request-to-publish',
        subject: this.props.t('requesttopublish'),
        state: {
          icon: requestToPublishOnClone ? 'icon-check' : 'icon-close',
          color: requestToPublishOnClone ? 'green' : 'red'
        },
        info2: {
          icon: requestToPublishOnClone && projectData.date_publish_requested != null ? 'icon-date' : '',
          text: requestToPublishOnClone && projectData.date_publish_requested != null ? formatDate(projectData.date_publish_requested) : ''
        }
      }); // show info if no project registration was found

      if (projectStateData == null) {
        rowData.push({
          type: 'project-state-data',
          subject: this.props.t('Projectdata'),
          state: {
            icon: 'icon-close',
            color: 'red'
          }
        });
      } else {
        // Project state
        projectIsChecked = projectStateData.project_checked_by && projectStateData.project_checked_at;
        var projectState = {
          type: 'project-state-data',
          subject: this.props.t('Projectdata'),
          state: {
            icon: projectIsChecked ? 'icon-check' : 'icon-close',
            color: projectIsChecked ? 'green' : 'red'
          },
          info1: function info1() {
            if (projectIsChecked) return;
            return /*#__PURE__*/_react.default.createElement("button", {
              className: "btn btn--small",
              onClick: _this3.checkProject
            }, _this3.props.t('Check project data'));
          }
        };

        if (projectIsChecked) {
          Object.assign(projectState, {
            info1: {
              icon: 'icon-user',
              text: projectStateData.project_checked_by.email
            },
            info2: {
              icon: 'icon-date',
              text: formatDate(projectStateData.project_checked_at)
            }
          });
        }

        rowData.push(projectState); // Release state

        var IsReleased = projectStateData.released_by && projectStateData.released_at,
            releaseState = {
          type: 'release-state-data',
          subject: this.props.t('release'),
          state: {
            icon: IsReleased ? 'icon-check' : 'icon-close',
            color: IsReleased ? 'green' : 'red'
          },
          info1: function info1() {
            if (IsReleased) return;
            var disabled = false;
            if ((_this3.props.projectKey === 'brunch' || _this3.props.projectKey === 'lockpfosten') && (!projectIsChecked || !farmIsChecked || !membershipDataPayd)) disabled = true;
            if (!projectIsChecked || !farmIsChecked) disabled = true;
            return /*#__PURE__*/_react.default.createElement("button", {
              className: "btn btn--small",
              onClick: _this3.releaseProject,
              disabled: disabled
            }, _this3.props.t('Release project'));
          }
        };
        if (projectIsChecked && farmIsChecked) if (IsReleased) {
          Object.assign(releaseState, {
            info1: {
              icon: 'icon-user',
              text: projectStateData.released_by.email
            },
            info2: {
              icon: 'icon-date',
              text: formatDate(projectStateData.released_at)
            },
            info3: function info3() {
              return /*#__PURE__*/_react.default.createElement("button", {
                className: "btn btn--small",
                onClick: _this3.resetReleaseProject
              }, _this3.props.t('Reset release project'));
            }
          });
        }
        rowData.push(releaseState);
      }

      return rowData;
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this4 = this;

      var loadProjectReleaseState = fetch(_conf.default.api.projectReleaseStatusByFarmUrl(this.props.i18n.language, this.props.farmId, this.props.projectKey), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        if (err.error.status !== 404) {
          void 0;
          return {};
        }

        return {
          project_checked_by: null,
          project_checked_at: null,
          released_by: null,
          released_at: null,
          date_create: null,
          date_publish_requested: null
        };
      });
      var loadUser = fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, this.props.farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        void 0;
        return {};
      });
      var farmReleaseStatus = fetch(_conf.default.api.farmReleaseStatusUrl(this.props.i18n.language, this.props.farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        if (err.error.status !== 404) {
          void 0;
          return {};
        }

        return {
          farm_checked_by: null,
          farm_checked_at: null
        };
      });
      var membershipStatus = fetch(_conf.default.api.membershipFeeFromFarmApiUrlTemplate(this.props.i18n.language, this.props.farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        if (err.error.status === 404) return;
        void 0;
      });
      return _bluebird.default.join(loadProjectReleaseState, loadUser, farmReleaseStatus, membershipStatus, function (projectState, userState, farmState, membershipState) {
        _this4.projectStateData = projectState;
        _this4.userStateData = userState;
        _this4.farmStateData = farmState;
        _this4.membershipData = membershipState;

        _this4.setState(function (prev) {
          prev.data = _this4.transformData(projectState, userState, farmState, membershipState);
          prev.isLoading = false;
          return prev;
        });
      });
    }
  }, {
    key: "updateStatusesDisplay",
    value: function updateStatusesDisplay() {
      var _this5 = this;

      this.setState(function (prev) {
        prev.data = _this5.transformData(_this5.projectStateData, _this5.userStateData, _this5.farmStateData, _this5.membershipData);
        prev.isLoading = false;
        return prev;
      });
    }
  }, {
    key: "updateMembershipInfo",
    value: function updateMembershipInfo() {
      var _this6 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.membershipFeeFromFarmApiUrlTemplate(this.props.i18n.language, this.props.farmId), {
        credentials: 'include',
        method: 'POST'
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this6.membershipData = response;

        _this6.updateStatusesDisplay();
      }).catch(function (err) {
        _this6.setState({
          isLoading: false
        });

        void 0;
      });
    }
  }, {
    key: "resetMembershipInfo",
    value: function resetMembershipInfo() {
      var _this7 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.membershipFeeFromFarmApiUrlTemplate(this.props.i18n.language, this.props.farmId), {
        credentials: 'include',
        method: 'DELETE'
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this7.membershipData = null;

        _this7.updateStatusesDisplay();
      }).catch(function (err) {
        _this7.setState({
          isLoading: false
        });

        void 0;
      });
    }
  }, {
    key: "checkFarmData",
    value: function checkFarmData() {
      var _this8 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.updateFarmReleaseStatusUrl(this.props.i18n.language, this.props.farmId), {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(_lodash.default.merge(this.farmStateData, {
          projectKey: this.props.projectKey
        })),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this8.farmStateData = response;

        _this8.updateStatusesDisplay();
      }).catch(function (err) {
        _this8.setState({
          isLoading: false
        });

        void 0;
      });
    }
  }, {
    key: "checkProject",
    value: function checkProject() {
      var _this9 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.checkProjectStatusUrl(this.props.i18n.language, this.props.farmId, this.props.projectKey), {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          projectKey: this.props.projectKey
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this9.projectStateData = response;

        _this9.updateStatusesDisplay();
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "releaseProject",
    value: function releaseProject() {
      var _this10 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.releaseProjectStatusUrl(this.props.i18n.language, this.props.farmId, this.props.projectKey), {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          projectKey: this.props.projectKey
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this10.projectStateData = response;

        _this10.updateStatusesDisplay();
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "resetReleaseProject",
    value: function resetReleaseProject() {
      var _this11 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.releaseProjectStatusUrl(this.props.i18n.language, this.props.farmId, this.props.projectKey), {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this11.projectStateData = response;

        _this11.updateStatusesDisplay();
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return ProjectState;
}(_react.default.Component);

ProjectState.propTypes = {
  t: _propTypes.default.any.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  projectKey: _propTypes.default.string.isRequired,
  farmId: _propTypes.default.string.isRequired,
  projectData: _propTypes.default.object
};

var _default = (0, _translate.default)(ProjectState);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-state/index.js
// module id = 69
// module chunks = 0